type Listener = (visible: boolean) => void

let pending = 0
let visible = false
let showTimer: number | null = null
let hideTimer: number | null = null
let shownAt = 0

const listeners = new Set<Listener>()

const SHOW_DELAY_MS = 180
const MIN_VISIBLE_MS = 350

function emit(next: boolean) {
  if (visible === next) return
  visible = next
  listeners.forEach((fn) => fn(visible))
}

function scheduleShow() {
  if (visible || showTimer != null) return
  showTimer = window.setTimeout(() => {
    showTimer = null
    if (pending > 0) {
      shownAt = Date.now()
      emit(true)
    }
  }, SHOW_DELAY_MS)
}

function scheduleHide() {
  if (showTimer != null) {
    window.clearTimeout(showTimer)
    showTimer = null
  }
  if (!visible) return
  const elapsed = Date.now() - shownAt
  const wait = Math.max(0, MIN_VISIBLE_MS - elapsed)
  if (hideTimer != null) window.clearTimeout(hideTimer)
  hideTimer = window.setTimeout(() => {
    hideTimer = null
    if (pending <= 0) emit(false)
  }, wait)
}

/** Increment in-flight API count (axios request). */
export function globalLoadingBegin() {
  pending += 1
  if (hideTimer != null) {
    window.clearTimeout(hideTimer)
    hideTimer = null
  }
  scheduleShow()
}

/** Decrement in-flight API count (axios response/error). */
export function globalLoadingEnd() {
  pending = Math.max(0, pending - 1)
  if (pending === 0) scheduleHide()
}

export function subscribeGlobalLoading(fn: Listener): () => void {
  listeners.add(fn)
  fn(visible)
  return () => listeners.delete(fn)
}

export function isGlobalLoadingVisible() {
  return visible
}
